import moment from 'moment'
import { getSubOrders } from '../../HttpRequests/subOrders'
import { loadSubOrders } from '../State/subOrders'

let lastGetTimestamp = null

const cacheTTL = 60000

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'))

      if (now < (lastGetTimestamp + cacheTTL)) return

    }
      
    lastGetTimestamp = Number(moment().format('x'))

    const params = {
      sort: 'reference',
      pagination: 0,
    }

    const response = await getSubOrders({ params })

    dispatch(loadSubOrders(response.data))

  } catch (error) {
    
    throw error

  }

}
